/**
 *
 * @author Matthew Rawson @ 08/02/2018 15:56
 * @description
 * @notes
 */
import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import {get} from "lodash"
import {OverlayTrigger, Tooltip} from "react-bootstrap"

import connect from "@irati/store/connect"
import id from "@irati/utils/id"
import {Label2 as Label, Para} from "@irati/ui/src/Labels"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import {FormattedMessage} from "@irati/utils/lang"


import AnonymousSvg from "./Anonymous.svg"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`


const StyledImg = styled.img`
  margin-right: ${padding.tiny};
  width: ${(props) => (props.large ? "60px" : "30px")};
  height: ${(props) => (props.large ? "60px" : "30px")};
`

const StyledLabel = styled(Label)`
  color: ${greys.mediumDark};
  text-align: left;
`


const AnonymousLabel = (props) => {
  const idNamespace = id("anonymous-label", props)
  const mqGreaterThanSmall = get(props.mq, "greaterThan.small", false) || false

  return (
    <Container id={idNamespace}>
      <OverlayTrigger
        placement="bottom"
        overlay={(
          <Tooltip id={id("tooltip", idNamespace)}>
            <Para><FormattedMessage id="survey.header.anonymousLabel.toolTip.text" /></Para>
          </Tooltip>
        )}>
        <div>
          <StyledImg
            id={id("img", idNamespace)}
            large={props.large}
            src={AnonymousSvg}
            alt="Anonymous user" />
          <StyledLabel id={id("label", idNamespace)}>
            {<span>{(mqGreaterThanSmall || props.large)
              ? <FormattedMessage id="insights.userSurvey.header.anonymousLabel.text" />
              : <FormattedMessage id="insights.userSurvey.header.anonymousLabel.label" />}</span>}
          </StyledLabel>
        </div>
      </OverlayTrigger>
    </Container>
  )
}

AnonymousLabel.propTypes = {
  large: PropTypes.bool,
  mq: PropTypes.object
}

AnonymousLabel.defaultProps = {
  large: false,
  mq: {}
}

const mapStateToProps = ({mq}) => ({mq})

export default connect(mapStateToProps)(AnonymousLabel)
